import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import EntityUserRoleAssignmentsPage from '@features/user/pages/EntityUserRoleAssignmentsPage';
import { useEntityContext } from '@features/entity/hooks/usePermissions';
import { formatEntityScopeLabel } from '@features/entity/constants/entityScopePicker';

const ChurchUserRoleAssignmentsPage: React.FC = () => {
  const { churchId } = useParams<{ churchId: string }>();
  const { context } = useEntityContext();

  const selectedEntityDisplayName = useMemo(() => {
    const name = context?.scopeName?.trim() || 'This Church';
    return formatEntityScopeLabel('CHURCH', name.replace(/^Church:\s*/i, ''));
  }, [context?.scopeName]);

  return (
    <EntityUserRoleAssignmentsPage
      scope="CHURCH"
      scopeRefId={Number(churchId)}
      title="User role assignments"
      subtitle="Role assignments at this church"
      selectedEntityDisplayName={selectedEntityDisplayName}
      testId="church-user-role-assignments-search"
    />
  );
};

export default ChurchUserRoleAssignmentsPage;
